
import { APPROVAL } from 'utils'
import { create } from 'zustand'


type  StoreType = {
    approvalStatus: number | null
    isEdit: boolean
    isView: boolean
    setApproval: (status: number) => void
    resetApproval: () => void
}

export const useApprovalStore = create<StoreType>((set) => ({
  approvalStatus: null,
  isEdit: false,
  isView: false,
  setApproval: (status: number) => set({
    approvalStatus: status,
    isEdit: status !== APPROVAL.APPROVED && status !== APPROVAL.REJECTED,
    isView: status === APPROVAL.APPROVED || status === APPROVAL.REJECTED
  }),

  resetApproval: () => set({
    approvalStatus: null,
    isEdit: false,
    isView: false
  })
}))